import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { HeaderComponent } from '@plantefeve/common/shared/components/header/header.component';

@Component({
  selector: 'igx-not-linked',
  imports: [HeaderComponent, TranslatePipe],
  template: `
    <igx-header [title]="'accountNotLinkedTitle' | translate"></igx-header>
    <section class="portal-notice">
      <p class="portal-notice__message" data-testid="account-not-linked">{{ 'accountNotLinkedMessage' | translate }}</p>
    </section>
  `,
})
export class NotLinkedComponent {}
